import React from 'react';

export default function ReleaseCard({ version, date, title, children }) {
  return (
    <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
      <div className="flex items-center mb-4">
        <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
          <h3 className="text-2xl font-semibold text-purple-400">{version}</h3>
          <span className="text-sm text-gray-400">{date}</span>
        </div>
      </div>
      <h4 className="text-lg font-medium text-white mb-3">{title}</h4>
      {children}
    </div>
  );
}
